import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import loginInfoReducer from "../src/state/loginInfoSlice";
import reportWebVitals from "./reportWebVitals";
import stdFormTypeReducer from "../src/state/standardFormTypeSlice";
import bpReducer from "../src/state/businessProcesseSlice";
import orgUnitReducer from "../src/state/orgUnitsSlice";
import orgUnitItemReducer from "../src/state/orgUnitItemSlice";
import licenseReducer from "../src/state/licenseSlice";
import userReducer from "../src/state/userSlice";
import userListReducer from "../src/state/userListSlice";
import userSettingReducer from "../src/state/userSettingsSlice";
import roleReducer from "../src/state/roleSlice";
import roleListReducer from "../src/state/roleListSlice";
import bpItemReducer from "../src/state/businessProcessItemSlice";
import ftListReducer from "./state/formTypeListSlice";
import formTypeReducer from "../src/state/formTypeItemSlice";
import extenderItemReducer from "../src/state/extenderItemSlice";
import connectionsReducer from "../src/state/connectionsSlice";
import navReducer from "../src/state/navSlice";
import docItemReducer from "../src/state/DocumentItemSlice";
import docAttachmentsReducer from "../src/state/DocAttachmentSlice";
import docImageReducer from "../src/state/docImageSlice";
import systemSettingsReducer from "../src/state/systemSettingsSlice";
import appReducer from "../src/state/appSlice";
import activeDocumentReducer from "../src/state/activeDocumentsSlice";
import activeDocumentListReducer from "../src/state/activeDocumentListSlice";
import screenSizeReducer from "../src/state/screenSizeSlice";
import companionReducer from "../src/state/companionSlice";
import aiOCRReducer from "../src/state/aiOCRSlice";
const store = configureStore({
  reducer: {
    loginInfo: loginInfoReducer,
    stdFTInfo: stdFormTypeReducer,
    bpInfo: bpReducer,
    bpItemInfo: bpItemReducer,
    orgUnitInfo: orgUnitReducer,
    orgUnitItemInfo: orgUnitItemReducer,
    licenseInfo: licenseReducer,
    userInfo: userReducer,
    userListInfo: userListReducer,
    userSettingInfo: userSettingReducer,
    roleInfo: roleReducer,
    roleListInfo: roleListReducer,
    ftListInfo: ftListReducer,
    formTypeInfo: formTypeReducer,
    extenderItemInfo: extenderItemReducer,
    connectionsInfo: connectionsReducer,
    navInfo: navReducer,
    documentInfo: docItemReducer,
    docAttachmentsInfo: docAttachmentsReducer,
    docImageInfo: docImageReducer,
    appInfo: appReducer,
    systemSettingsInfo: systemSettingsReducer,
    screenSizeInfo: screenSizeReducer,
    activeDocumentsInfo: activeDocumentReducer,
    activeDocumentListInfo: activeDocumentListReducer,
    companionInfo: companionReducer,
    aiOCRInfo: aiOCRReducer
  }
});
ReactDOM.render(
  /* @__PURE__ */ React.createElement(React.StrictMode, null, /* @__PURE__ */ React.createElement(Provider, { store }, /* @__PURE__ */ React.createElement(App, null))),
  document.getElementById("root")
);
reportWebVitals();
